/**
 * Retorna o nome de exibição do cliente priorizando o nome fantasia (tradeName)
 * com fallback para a razão social (name).
 */
export function getClientDisplayName(client: {
  name: string;
  tradeName?: string | null;
}): string {
  return client.tradeName?.trim() || client.name;
}
